"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _lodash = /*#__PURE__*/ _interop_require_default(require("lodash"));
var _fp = require("lodash/fp");
var _isactive = /*#__PURE__*/ _interop_require_default(require("../../offer/is-active"));
var _gettargetsegments = /*#__PURE__*/ _interop_require_default(require("../../offer/helpers/get-target-segments"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// An offer is deemed to be active if the following are true.
// - Is offer available (check release dates).
// - Does offer have the requested target segment?
// - If there are multiple offers that are available & have this segment, then the one that has the latest start date should be the one that is displayed.
// Discussion https://ahmhealthinsurance.slack.com/archives/CGPTKNTK5/p1585704050003000
var findActiveByTargetSegment = function(offers, targetSegment) {
    var scenario = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return (0, _lodash.default)(offers).filter(function(offer) {
        return (0, _fp.includes)(_lodash.default.toLower(targetSegment), (0, _gettargetsegments.default)(offer));
    }).filter(function(offer) {
        return (0, _isactive.default)(offer, scenario);
    }).sortBy('release.startTime', '_createdAt').value() || null;
};
var _default = findActiveByTargetSegment;
